module.exports = __webpack_public_path__ + "img/ABRAZADEA DE ARRANQUE.a17844b2.jpg";